import styles from "./Question.module.scss";
import Answer from "../Answer/Answer";
import classNames from "classnames";
import MoreInfoAccordion from "../MoreInfoAccordion/MoreInfoAccordion";
import { QuestionInfo } from "../types";

type Props = {
  id: string;
  step: string;
  question: string;
  information?: QuestionInfo;
  onAnswered: (id: string, answer: boolean) => void;
};

const Question = ({ step, id, question, information, onAnswered }: Props) => (
  <div
    className={classNames(
      styles.question,
      information?.gradingHelps.length && styles["question--with-info"],
    )}
    key={id}
  >
    <div className={styles.question__wrapper}>
      <p className={styles.question__text}>
        <span className={styles.question__step}>{step}</span>
        {question}
      </p>
      <div className={styles.question__answers}>
        <Answer
          id={id}
          label="Yes"
          onSelect={() => onAnswered(id, true)}
          applyFocus
        />
        <Answer id={id} label="No" onSelect={() => onAnswered(id, false)} />
      </div>
    </div>

    {information && <MoreInfoAccordion {...information} />}
  </div>
);

export default Question;
